import { beginSyncDiagnosticRun, recordSyncDiagnostic, renderBootstrapFailure, withBootstrapTimeout } from '@/services/syncDiagnostics'
import { installReleasePrepareHook } from '@/services/releaseRuntime'
import { BUNDLE_BUILD_META } from '@/generated/buildMeta'
import {
  captureClientError,
  installPreBootstrapClientErrorReporting
} from '@/services/clientErrorTelemetry'

if (typeof window !== 'undefined') {
  window.__AGROEL_BUNDLE_META__ = Object.freeze({ ...BUNDLE_BUILD_META })
}

beginSyncDiagnosticRun('bootstrap')
installPreBootstrapClientErrorReporting()
installReleasePrepareHook()

async function startApplication () {
  const gate = window.__AGROEL_RELEASE_GATE__
  const result = gate && typeof gate.then === 'function'
    ? await withBootstrapTimeout(gate, 60000, 'RELEASE_GATE_TIMEOUT')
    : { allowBootstrap: true, reason: 'gate-missing' }
  if (result?.allowBootstrap === false) return
  // A release can be deliberately deferred while a critical PLC write is in
  // flight. In that case verify the still-running shell against its own HTML
  // and controller, while the gate's retry keeps the newer target pending.
  const bundleVerification = result?.deferred === true
    ? await withBootstrapTimeout(window.__AGROEL_RELEASE_RUNTIME__?.verifyBundle?.(
      BUNDLE_BUILD_META,
      window.__AGROEL_RELEASE_META__
    ))
    : await withBootstrapTimeout(window.__AGROEL_RELEASE_RUNTIME__?.verifyBundle?.(BUNDLE_BUILD_META))
  if (bundleVerification?.ok === false || bundleVerification?.allowBootstrap === false) return
  recordSyncDiagnostic('bootstrap')
  await withBootstrapTimeout(import('./appBootstrap'))
}

startApplication().catch(error => {
  captureClientError(error, {
    level: 'fatal',
    event_kind: 'pwa.bootstrap.import-failed',
    final_failure: true
  })
  renderBootstrapFailure(error)
})
